import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { financeFormat } from '@home/utils/common';
import { getPlatformIcons } from '@intelligence/utils/common';
import { toFixed } from '@/pages/intelligence/utils/commonUtils';
import { platformColorMap } from '@intelligence/components/OverviewCard/components/CardPlatformContent/config';

import './index.scss';

interface ICardPlatformContent {
  platformList: {
    value: number;
    percent: string;
    percent_int: number;
    platform: 'PC' | 'Nintendo' | 'Xbox' | 'PS';
  }[];
}

function CardPlatformContent({ platformList }: ICardPlatformContent) {
  const { formatMessage } = useIntl();

  // PC 平台数据
  const pcPlatformInfo = platformList?.find((item) => item.platform === 'PC');

  // Console 平台数据
  const consolePlatformInfo = useMemo(() => {
    const platforms = platformList
      ?.filter((item) => item.platform !== 'PC')
      ?.map((item) => {
        return { ...item, color: '#000' };
      })
      ?.sort((a, b) => b.value - a.value);

    // 计算 console 总值及总占比
    const totalInfo = platforms?.reduce(
      (prev, curr) => {
        // eslint-disable-next-line no-param-reassign
        prev.totalValue += curr.value;
        // eslint-disable-next-line no-param-reassign
        prev.totalPercent = toFixed(prev.totalPercent + curr.percent_int, 1);
        return prev;
      },
      {
        totalPercent: 0,
        totalValue: 0,
      },
    );

    return {
      platforms,
      ...totalInfo,
    };
  }, [platformList]);

  if (!platformList?.length) {
    return (
      <div className="dbi-card-platform-container no-data">
        {formatMessage({ id: 'dbi_no_data_available' })}
      </div>
    );
  }

  return (
    <div className="dbi-card-platform-container">
      {/* PC 平台展示 */}
      {pcPlatformInfo && (
        <div>
          <div className="dbi-card-platform-text">
            PC: {financeFormat(pcPlatformInfo.value, 2, false, '')}({pcPlatformInfo.percent})
          </div>
          <div className="dbi-platform-bar-container">
            <div
              className="dbi-platform-bar-item"
              style={{ width: pcPlatformInfo.percent, background: platformColorMap.PC }}
            ></div>
          </div>
        </div>
      )}

      {/* Console 平台展示 */}
      {Boolean(consolePlatformInfo?.platforms?.length) && (
        <div className="dbi-card-platform-console-container">
          <div className="dbi-card-platform-text">
            Console: {financeFormat(consolePlatformInfo.totalValue, 2, false, '')}(
            {consolePlatformInfo.totalPercent}%)
          </div>

          <div className="dbi-platform-bar-container">
            {consolePlatformInfo?.platforms?.map((item, index) => (
              <div
                key={index}
                style={{ width: item.percent, background: platformColorMap[item.platform] }}
              ></div>
            ))}
          </div>

          <div className="dbi-platform-bar-legend">
            {consolePlatformInfo?.platforms?.map((item, index) => (
              <div key={index} className="dbi-platform-bar-legend-item">
                <div
                  className="dbi-platform-bar-legend-marker"
                  style={{ background: platformColorMap[item.platform] }}
                />
                <img src={getPlatformIcons(item.platform)} alt="" />
                <div className="dbi-platform-bar-legend-info">
                  {item.platform}: {financeFormat(item.value, 2, false, '')} ({item.percent})
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CardPlatformContent;
